module.exports = __webpack_public_path__ + "static/media/globe.1cd344a8.svg";